// 模板 2：另一套行业化官网风格（首页 + newsTemplate1 + softwareTemplate1）

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '园区运营数字驾驶舱',
        content:
          '以数据大屏集中呈现园区资产、招商进度与运营指标，帮助管理团队实时掌握整体运营态势。'
      },
      {
        img: require('@/assets/img/banner1.png'),
        path: '',
        title: '一体化企业服务入口',
        content:
          '为入驻企业提供线上办事大厅，从报修、预约到费用查询一站式办理，提升园区服务体验。'
      },
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '开放的生态连接能力',
        content:
          '通过标准化接口对接第三方系统与增值服务，让园区可以灵活组合各类创新应用。'
      },
      {
        img: require('@/assets/img/banner_2.jpg'),
        path: '',
        title: '持续运营与增值服务',
        content:
          '结合数据分析与行业经验，为园区提供招商策略、活动运营与品牌推广等增值服务。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '园区运营数据中台',
      subtitle: '/ Campus Operation Data Hub',
      paragraphs: [
        '围绕园区资产、企业、合同、能耗与人流车流等多源数据，构建统一的数据中台，为招商、运营与服务提供统一的数据基础。',
        '通过预置的指标体系与可配置的看板组件，管理者可以从不同维度审视园区经营状况，快速发现问题并验证运营策略效果。'
      ],
      buttonText: '预约园区方案演示'
    },
    contact: {
      title: '值得托付的园区数字化伙伴',
      subTitle: '用专业能力支撑园区长期稳健运营',
      buttonText: '联系园区顾问'
    },
    customers: [
      {
        logo: require('@/assets/img/logo_toyota.png'),
        title: '产业园区 · 运营总监',
        content:
          '平台帮助我们把分散在 Excel 和多套系统中的数据集中起来，招商进度、出租率和费用回款一目了然，管理效率提升非常明显。'
      },
      {
        logo: require('@/assets/img/logo_kk.png'),
        title: '科技园区 · 服务中心负责人',
        content:
          '通过企业服务门户，企业可以在线提交诉求和办事申请，工单流转和反馈过程也更加透明，整体服务满意度有了显著提升。'
      },
      {
        logo: require('@/assets/img/logo_hp.png'),
        title: '新城片区 · 管理委员会代表',
        content:
          '数据中台让我们能更全面地了解园区产业发展情况，为制定产业扶持政策和资源配置提供了有力的数据支撑。'
      }
    ],
    advantages: [
      {
        icon: require('@/assets/img/computer.png'),
        title: '深耕园区场景',
        html: '<p>覆盖多类型产业园区</p>熟悉从招商到运营的全流程管理诉求'
      },
      {
        icon: require('@/assets/img/qiniu.png'),
        title: '灵活部署架构',
        html: '<p>支持公有云与私有化部署</p>满足不同园区的信息安全要求'
      },
      {
        icon: require('@/assets/img/tel.png'),
        title: '运营陪伴服务',
        html: '<p>不仅交付系统</p>还提供持续的运营咨询与方案优化建议'
      },
      {
        icon: require('@/assets/img/logo_white.png'),
        title: '开放生态能力',
        html: '<p>对接第三方应用</p>打造可持续演进的园区数字生态'
      }
    ]
  },
  company: {
    name: '云栖园区运营科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__专注产业园区与科创园区的数字化运营解决方案，围绕资产管理、招商运营与企业服务三大核心场景，为园区管理方提供一体化的平台支撑。',
      '团队成员在园区运营管理与信息化建设领域拥有多年经验，既理解园区一线业务的痛点，也熟悉大规模系统设计与实施方法，致力于用持续可演进的平台能力，帮助园区实现精细化运营与品牌价值提升。'
    ]
  },
  news: [
    {
      id: 'A03',
      title: '发布新一代行业解决方案平台',
      introduce:
        '公司正式发布新一代行业解决方案平台，在架构、性能和易用性方面进行了全面升级，支持更多场景的快速配置与交付。',
      date: '09-20',
      year: '2024'
    },
    {
      id: 'A02',
      title: '与头部生态伙伴达成战略合作',
      introduce:
        '公司与多家云厂商及生态伙伴签署战略合作协议，围绕产品集成、市场拓展与联合服务等方面展开深度合作，为客户提供更完整的一站式解决方案。',
      date: '06-03',
      year: '2024'
    },
    {
      id: 'A01',
      title: '技术团队在行业大会分享最佳实践',
      introduce:
        '在近期举办的某行业技术大会上，公司技术团队受邀进行主题演讲，分享了在大规模系统稳定性与数据治理方面的实践经验，受到与会嘉宾的一致好评。',
      date: '12-10',
      year: '2023'
    },
    {
      id: 'A00',
      title: '推出面向开发者的开放平台',
      introduce:
        '公司面向生态伙伴推出开放平台，提供统一的 API 网关与开发者中心，方便第三方快速接入并构建行业应用。',
      date: '03-05',
      year: '2023'
    },
    {
      id: 'B01',
      title: '海外数据中心正式投入使用',
      introduce:
        '为满足全球化客户的合规与就近接入需求，公司在海外部署的数据中心正式上线运营，为跨区域业务提供更低时延与更高可用性保障。',
      date: '09-26',
      year: '2022'
    }
  ],
  software: {
    smartTown: {
      title: '园区运营支撑系统 · 场景方案 A',
      sections: [
        {
          heading: '1. 园区资产一张图',
          content:
            '系统将园区内楼宇、厂房、配套设施等资产信息统一建档，通过空间一张图的形式直观呈现出租率、到期情况与空置分布，帮助运营方快速掌握整体资产健康度。'
        },
        {
          heading: '2. 入驻企业全生命周期管理',
          content:
            '从招商线索跟进、合同签署到日常服务与续约提醒，系统为入驻企业提供全生命周期管理能力，并结合企业画像与产业定位，支持精细化运营与政策匹配。'
        },
        {
          heading: '3. 园区服务在线化',
          content:
            '通过企业服务门户与移动端小程序，企业可以在线发起报修、预约会议室、申请车辆通行等高频事项，运维人员可在系统中查看工单、安排处理并回访评价。'
        },
        {
          heading: '4. 运营数据驾驶舱',
          content:
            '系统将租金收入、费用回款、工单处理效率与园区人流车流等关键指标集中到运营驾驶舱中，让管理者可以实时洞察园区运营状况，及时调整招商与服务策略。'
        }
      ]
    },
    bigData: {
      title: '运营数据中台 · 功能亮点',
      sections: [
        {
          heading: '1. 多源业务系统数据汇聚',
          desc:
            '通过标准化数据接入组件，对接财务、物业、能耗、门禁等多套业务系统，将分散存储的数据统一汇聚到数据中台，为后续分析建模提供基础。'
        },
        {
          heading: '2. 指标体系与看板配置',
          desc:
            '结合园区运营管理诉求，预置多主题指标模型，管理者可通过配置方式快速搭建各类业务看板，关注出租率、费用回收率、能耗水平等关键指标。'
        },
        {
          heading: '3. 预警与异常分析',
          desc:
            '针对欠费、异常能耗、工单超时等场景，系统支持配置规则自动触发预警，并通过关联分析功能帮助定位问题根因，降低运营风险。'
        },
        {
          heading: '4. 自助取数与报表导出',
          desc:
            '运营人员可以通过自助取数界面按需筛选维度与指标，制作个性化报表并导出，无需依赖技术人员编写 SQL 或开发报表。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '园区运营顾问服务',
      engTitle: 'Operation Consulting',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '平台实施与集成',
      engTitle: 'Implementation & Integration',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '数据运营与分析',
      engTitle: 'Data Operation',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '长期运维托管',
      engTitle: 'Managed Service',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '园区数字化解决方案顾问',
    responsibilities: [
      '深入理解园区客户的业务现状与发展规划，梳理数字化建设需求并形成整体方案；',
      '协同售前与产品团队完成方案宣讲、标书编写与招投标支持工作；',
      '跟进重点项目实施过程，沉淀可复制的园区数字化方法论与最佳实践。'
    ],
    requirements: [
      '具备产业园区、商业地产或相关行业经验，对园区运营模式有基本了解；',
      '具备良好的沟通表达与方案撰写能力，能够将复杂需求抽象为清晰的解决路径；',
      '适应一定频次的出差与现场工作，具备责任心与团队协作精神。'
    ],
    buttonText: '预约沟通'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-2.js